import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GroupBooking } from '@gtd/api-services/service-inventory';

@Component({
  selector: 'gtd-insurance',
  templateUrl: './insurance.component.html',
  styleUrls: ['./insurance.component.scss']
})
export class InsuranceComponent implements OnInit {
  @Input() bookingDetail: GroupBooking;
  @Input() isConfirmation = false;
  panelOpenState = true;
  constructor() {}

  ngOnInit() {}
}
